<template v-if="fetch_data">
  <div id="atsu_my_history" class="cts_box">
    <h2 class="sub_ttl"><span>アツアツ銘柄コンテストエントリー履歴</span></h2>
    <template v-if="fetch_data.entries.length == 0">
      <div class="event_box">
        <ul class="event_list">
          <li class="no_entry"><p>エントリー履歴はありません</p></li>
        </ul>
      </div>
    </template>
    <template v-else>
      <h3 class="min_ttl"><span>エントリー履歴と高騰率、順位</span></h3>
      <div class="rate_wrap flex">
        <p>アツアツ銘柄コンテストの参加履歴と高騰率・順位の算出を行っています。</p>
        <div class="rate_box flex" v-if="fetch_data.total_rank">
          <div class="max"><h4>最高騰落率：</h4>
            <p class="red">
              {{
                fetch_data.total_rank.rate_max ? (Math.round(fetch_data.total_rank.rate_max * 100) / 100).toFixed(2) + '%' : '-'
              }}
            </p>
          </div>
          <div class="min"><h4>平均騰落率：</h4>
            <p class="red">
              {{
                fetch_data.total_rank.rate_adv ? (Math.round(fetch_data.total_rank.rate_adv * 100) / 100).toFixed(2) + '%' : '-'
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="scrl_wrap">
        <div class="atsu_tbl_box">
          <table>
            <tbody>
            <tr>
              <th colspan="2"></th>
              <th>エントリー時</th>
              <th colspan="3">3か月判定時</th>
              <th colspan="3">1年判定時</th>
            </tr>
            <tr>
              <th>エントリー回<span class="shiki">（対象四季報）</span></th>
              <th class="min">銘柄</th>
              <th>株価</th>
              <th>株価</th>
              <th>騰落率</th>
              <th class="min">順位</th>
              <th>株価</th>
              <th>騰落率</th>
              <th class="min">順位</th>
            </tr>
            <template v-for="(m, index) in fetch_data.entries">
              <tr v-if="m.ranks" :key="'entry-' + index">
                <td>{{ getTitleNumber(m.title) }}<span class="shiki">（{{ getTitleDate(m.title) }}）</span></td>
                <td>
                  <p><a :href="'https://shikiho.toyokeizai.net/stocks/' + m.ranks.ticker"
                        target="_blank">{{ m.ranks.stock_name }}</a></p>
                  <p class="comment_btn" @click="comment = m.ranks.comment">コメント</p>
                </td>
                <td>{{ m.ranks.prices[0].price ? delimited(m.ranks.prices[0].price) + '円' : '-' }}<span
                    class="date">（{{ moment(m.ranks.prices[0].date, 'YYYY/MM/DD') }}）</span></td>

                <template v-if="!m.ranks.prices[1]">
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </template>
                <template v-else>
                  <td>{{ ranksMonth(m.ranks, 3).price ? delimited(ranksMonth(m.ranks, 3).price) + '円' : '-' }}<span
                      class="date">（{{ moment(ranksMonth(m.ranks, 3).date, 'YYYY/MM/DD') }}）</span></td>
                  <td class="rate-value"
                      v-bind:class="{plus: ranksMonth(m.ranks, 3).rate >= 0, minus: ranksMonth(m.ranks, 3).rate < 0}">
                    <template v-if="ranksMonth(m.ranks, 3).rank && ranksMonth(m.ranks, 3).rank !== 10000">
                      {{ ranksMonth(m.ranks, 3).rate >= 0 ? '+' : '' }}
                      {{ (Math.round(ranksMonth(m.ranks, 3).rate * 100) / 100).toFixed(2) + '%' }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>
                    {{ ranksMonth(m.ranks, 3).rank && ranksMonth(m.ranks, 3).rank !== 10000 ? delimited(ranksMonth(m.ranks, 3).rank) : '-' }}
                    <span class="status completed" v-if="m.ranks_3month_completed">確定</span>
                    <span class="status progress" v-else>進行中</span>
                  </td>

                  <td>{{ ranksMonth(m.ranks, 12).price ? delimited(ranksMonth(m.ranks, 12).price) + '円' : '-' }}<span
                      class="date">（{{ moment(ranksMonth(m.ranks, 12).date, 'YYYY/MM/DD') }}）</span></td>
                  <td class="rate-value"
                      v-bind:class="{plus: ranksMonth(m.ranks, 12).rate >= 0, minus: ranksMonth(m.ranks, 12).rate < 0}">
                    <template v-if="ranksMonth(m.ranks, 12).rank && ranksMonth(m.ranks, 12).rank !== 10000">
                      {{ ranksMonth(m.ranks, 12).rate >= 0 ? '+' : '' }}
                      {{ (Math.round(ranksMonth(m.ranks, 12).rate * 100) / 100).toFixed(2) + '%' }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>
                    {{ ranksMonth(m.ranks, 12).rank && ranksMonth(m.ranks, 12).rank !== 10000 ? delimited(ranksMonth(m.ranks, 12).rank) : '-' }}
                    <span class="status completed" v-if="m.ranks_12month_completed">確定</span>
                    <span class="status progress" v-else>進行中</span>
                  </td>
                </template>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <!-- modal -->
      <div class="modal open" v-if="comment">
        <div class="modal_box">
          <div class="header">
            <h4>コメント</h4>
            <div class="close modal_close" @click="comment = null"></div>
          </div>
          <div class="inner draft cart">
            <div class="scroll_wrap">
              <div class="scroll_box">
                <div class="item_detail flex">
                  {{ comment }}
                </div>
                <div class="btn_wrap">
                  <a href="javascript:void(0)" @click="comment = null" class="submit light skeleton">閉じる</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ovr"></div>
      </div>
      <!-- modal -->
    </template>
  </div>
</template>


<script>
import Libraries from '@/components/Libraries.vue'

export default {
  props: {
    user_id: null
  },
  mixins: [Libraries],
  data() {
    return {
      fetch_data: null,
      comment: null
    }
  },
  mounted() {
    this.fetchData()

  },
  methods: {
    ranksMonth(entry, month) {
      if (entry.prices[month]) {
        return entry.prices[month]
      } else {
        return this.lastPrice(entry)
      }
    },
    lastPrice(entry) {
      return [...entry.prices].reverse().find(v => v !== null);
    },
    getTitleNumber(title) {
      return title.split(' ')[0]
    },
    getTitleDate(title) {
      return title.split(' ')[2]
    },
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/entries.json`, {
            params: {
              user_id: this.user_id,
            }
          })
          .then(response => {
            this.fetch_data = response.data
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
  }
}
</script>

